import { render, staticRenderFns } from "./authCamera.vue?vue&type=template&id=3f0d6f3c&scoped=true&"
import script from "./authCamera.vue?vue&type=script&lang=js&"
export * from "./authCamera.vue?vue&type=script&lang=js&"
import style0 from "./authCamera.vue?vue&type=style&index=0&id=3f0d6f3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0d6f3c",
  null
  
)

export default component.exports